import { createClient } from "@supabase/supabase-js";

const rawUrl = process.env.REACT_APP_SUPABASE_URL || "";
const rawAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

const supabaseUrl = rawUrl.trim();
const supabaseAnonKey = rawAnonKey.trim();

function isPlaceholder(value) {
  return !value || value.includes("xxxx") || value.includes("ضع_") || value.includes("رابط_المشروع") || value.includes("anon_public_key");
}

export const supabaseConfigError =
  isPlaceholder(supabaseUrl) || isPlaceholder(supabaseAnonKey)
    ? "بيانات Supabase غير مكتملة. تأكد من ملف frontend/.env وضع Project URL و anon public key الحقيقيين."
    : "";

if (supabaseConfigError) {
  console.error(supabaseConfigError, {
    hasUrl: Boolean(supabaseUrl),
    hasAnonKey: Boolean(supabaseAnonKey),
  });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
